module.exports = __webpack_public_path__ + "img/icon-47.f94a660d.svg";